const QUALITY_ASSESSMENT_BASE_PATH = '/cmx/quality-assessment/';

export type ReturnToWorklistQuery = {
  projectId?: string;
  status?: string;
};

/**
 * Builds the quality assessment worklist path with optional projectId/status
 * query params. Used when navigating back to the CQA list from the grading
 * screen (e.g. direct link or after submit). Callers are responsible for
 * dispatching navigation with the returned path.
 * Accepts any context that may have returnToWorklistQuery (e.g. augmented CursorAPIContext).
 */
export function buildQualityAssessmentWorklistPath(
  cursorAPIContext: unknown
): string {
  const returnToWorklistQuery = (cursorAPIContext as { returnToWorklistQuery?: ReturnToWorklistQuery })?.returnToWorklistQuery;
  const params = new URLSearchParams();
  if (returnToWorklistQuery?.projectId) {
    params.set('projectId', returnToWorklistQuery.projectId);
  }
  if (returnToWorklistQuery?.status) {
    params.set('status', returnToWorklistQuery.status);
  }
  return params.toString()
    ? `${QUALITY_ASSESSMENT_BASE_PATH}?${params.toString()}`
    : QUALITY_ASSESSMENT_BASE_PATH;
}
